import { InferRequestType, InferResponseType } from "hono";
import { useMutation } from "react-query";

import { useGlobalStore } from "~/stores/global";
import { useHonoClient } from "./HonoContext";

export const useCreateAccount = () => {
  const { refreshStore } = useGlobalStore(true);
  const { hc } = useHonoClient();
  const createAccount = hc.accounts.$post;

  const { mutateAsync, ...rest } = useMutation<
    InferResponseType<typeof createAccount>,
    undefined,
    InferRequestType<typeof createAccount>["json"]
  >(
    async (data) => {
      const result = (
        await createAccount({
          json: data,
        })
      ).json();
      return result;
    },
    {
      onSuccess: () => {
        return refreshStore();
      },
    },
  );

  return {
    createAccount: mutateAsync,
    ...rest,
  };
};
